import vendorAssets from "../../../config/vendor_assets.json"

const pending = {}

export async function ensureLeaflet() {
  ensureStylesheet(vendorAssets.leaflet.css)
  if (window.L) return window.L
  await ensureScript(vendorAssets.leaflet.js)
  return window.L
}

// MapLibre GL (the trail map) — same engine the iOS app uses, so bearing/pitch
// camera behavior can match it.
export async function ensureMapLibre() {
  ensureStylesheet(vendorAssets.maplibre.css)
  if (window.maplibregl) return window.maplibregl
  await ensureScript(vendorAssets.maplibre.js)
  return window.maplibregl
}

export async function ensureChart() {
  if (window.Chart) return window.Chart
  await ensureScript(vendorAssets.chart.js)
  return window.Chart
}

function ensureStylesheet({ id, href, integrity, crossorigin }) {
  if (document.getElementById(id) || document.querySelector(`link[href="${href}"]`)) return
  const link = document.createElement("link")
  link.id = id
  link.rel = "stylesheet"
  link.href = href
  if (integrity) {
    link.integrity = integrity
    link.crossOrigin = crossorigin || "anonymous"
  }
  document.head.appendChild(link)
}

function ensureScript({ id, src, integrity, crossorigin }) {
  if (pending[id]) return pending[id]
  const existing = document.getElementById(id) || document.querySelector(`script[src="${src}"]`)
  if (existing?.dataset.loaded === "true") return Promise.resolve()

  pending[id] = new Promise((resolve, reject) => {
    const script = existing || document.createElement("script")
    script.id ||= id
    script.src ||= src
    if (integrity) {
      script.integrity = integrity
      script.crossOrigin = crossorigin || "anonymous"
    }
    script.addEventListener("load", () => {
      script.dataset.loaded = "true"
      resolve()
    }, { once: true })
    script.addEventListener("error", event => {
      delete pending[id]
      script.remove?.()
      const error = new Error(`Failed to load ${id} from ${src}`)
      error.cause = event
      reject(error)
    }, { once: true })
    if (!existing) document.head.appendChild(script)
  })
  return pending[id]
}
